import * as Atom from 'effect/unstable/reactivity/Atom';

type AuthModalMode = 'login' | 'resetPassword' | 'addProductToFavourites';

export const AuthModalMode: Readonly<Record<AuthModalMode, AuthModalMode>> = {
  login: 'login',
  resetPassword: 'resetPassword',
  addProductToFavourites: 'addProductToFavourites',
};

type AuthModalState = {
  isOpen: boolean;
  mode: AuthModalMode;
  postLoginBehavior?: 'redirect' | 'reloadCurrent';
};

export const authModalAtom = Atom.make<AuthModalState>({
  isOpen: false,
  mode: AuthModalMode.login,
});
